var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOneway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1437 28.6842C12.3311 25.7849 15.112 21.4164 15.112 17.942C15.112 14.1081 11.7289 11 7.55598 11C3.38303 11 0 14.1081 0 17.942C0 21.4164 2.78083 25.7849 4.96851 28.6842C7.55598 31.2776 7.55598 31.2776 10.1437 28.6842ZM7.55614 20.4664C8.59937 20.4664 9.44523 19.6187 9.44523 18.5731C9.44523 17.5275 8.59937 16.6798 7.55614 16.6798C6.5129 16.6798 5.66724 17.5275 5.66724 18.5731C5.66724 19.6187 6.5129 20.4664 7.55614 20.4664Z",
    fill: "#C4BBFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0317 28.6842C39.2192 25.7849 42 21.4164 42 17.942C42 14.1081 38.617 11 34.444 11C30.2711 11 26.8881 14.1081 26.8881 17.942C26.8881 21.4164 29.6689 25.7849 31.8566 28.6842C34.444 31.2776 34.444 31.2776 37.0317 28.6842ZM34.4442 20.4664C35.4874 20.4664 36.3333 19.6187 36.3333 18.5731C36.3333 17.5275 35.4874 16.6798 34.4442 16.6798C33.4009 16.6798 32.5553 17.5275 32.5553 18.5731C32.5553 19.6187 33.4009 20.4664 34.4442 20.4664Z",
    fill: "#C4BBFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.3248,
    y: 19.6426,
    width: 9.60287,
    height: 2.40072,
    rx: 1.20036,
    fill: "#C4BBFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneway);
export default __webpack_public_path__ + "static/media/Oneway.eb6383be.svg";
export { ForwardRef as ReactComponent };